export default __webpack_public_path__ + "static/media/prize4.f7de9036.svg";